import { DotsHorizontalIcon } from "Icons/DotsHorizontal";
import { Dropdown } from "antd";

import { useState } from "react";

import { css } from "@emotion/react";
import { EmotionJSX } from "@emotion/react/types/jsx-namespace";

import { Button, Props as ButtonProps } from "components/shared/library/Button";

import { useCloseOnClickOutside } from "utils/libraryHooks";

import { white } from "constants/colors";

import { Props as MenuBarActionProps } from "./MenuBarAction";

type ChildProps = { key: string } & MenuBarActionProps;
type Props = {
  children?:
    | React.ReactElement<ChildProps>
    | React.ReactElement<ChildProps>[]
    | React.ReactNode[];
  MenuItems?: (props: { onClick: () => void }) => EmotionJSX.Element;
  buttonProps?: ButtonProps;
};

const style = {
  overlay: css({
    padding: 4,
    background: white,
    boxShadow: "0px 0px 0px 1px #F5F6FA, 0px 0px 8px rgba(72, 40, 228, 0.15)",
    borderRadius: 12,
    display: "flex",
    flexDirection: "column",
    gap: 4,
  }),
  innerOverlay: { boxShadow: "none", padding: 0, borderRadius: 12 },
};
export const MoreActionButton = ({
  children,
  MenuItems,
  buttonProps,
}: Props) => {
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  useCloseOnClickOutside(isMenuVisible, setIsMenuVisible, "more-action-menu");

  return (
    <Dropdown
      arrow={false}
      overlay={
        <div
          id="more-action-menu"
          data-testid="more-action-menu"
          css={style.overlay}
        >
          {MenuItems ? (
            <MenuItems onClick={() => setIsMenuVisible(!isMenuVisible)} />
          ) : (
            children
          )}
        </div>
      }
      open={isMenuVisible}
      autoAdjustOverflow
      disabled={buttonProps?.disabled}
    >
      <Button
        IconLeft={DotsHorizontalIcon}
        ariaLabel="More actions"
        color="gray"
        background="ghost"
        size="extra-small"
        onClick={(e) => {
          e.stopPropagation();
          setIsMenuVisible(!isMenuVisible);
        }}
        {...buttonProps}
      />
    </Dropdown>
  );
};
